import styled from 'styled-components'

export const ToggleFieldWrapper = styled.span`
  display: inline-flex;
  align-items: center;
`
